import React, { useEffect, useMemo, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp, faCommentDots } from "@fortawesome/free-solid-svg-icons";

import "./InternalCommentsChatDock.scss";
import InternalCommentsChatInline from "./InternalCommentsChat";

type TargetType = "review" | "sending" | 'review-phone-review';

type Props = {
  targetType: TargetType;
  targetId: number;
  currentUserKey: string;

  // Valfritt: om du vill att panelen börjar stängd
  defaultOpen?: boolean;

  // Valfritt: titel
  title?: string;

  // Valfritt: när ny kommentar skapas (t.ex. för att uppdatera hasInternalComment någonstans)
  onCreated?: () => void;
};

const InternalCommentsChatDock: React.FC<Props> = ({
  targetType,
  targetId,
  currentUserKey,
  defaultOpen = false,
  title,
  onCreated,
}) => {
  const [open, setOpen] = useState(defaultOpen);

  // om targetId/typ byts (navigerar mellan sändningar), stäng panelen som default
  useEffect(() => {
    setOpen(defaultOpen);
  }, [targetType, targetId, defaultOpen]);

  const headerTitle = useMemo(() => {
    if (title) return title;
    return targetType === "review"
      ? `Interna kommentarer – Granskning ${targetId}`
      : `Interna kommentarer – Utskick ${targetId}`;
  }, [title, targetType, targetId]);

  return (
    <div className={`ic-dock ${open ? "ic-dock--open" : "ic-dock--closed"}`}>
      <button
        type="button"
        className="ic-dock__header"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        title={open ? "Minimera" : "Öppna interna kommentarer"}
      >
        <div className="ic-dock__header-left">
          <FontAwesomeIcon icon={faCommentDots} />
          <span className="ic-dock__title">{headerTitle}</span>
        </div>

        <div className="ic-dock__header-right">
          <FontAwesomeIcon icon={open ? faChevronDown : faChevronUp} />
        </div>
      </button>

      <div className="ic-dock__body" aria-hidden={!open}>
       
        <InternalCommentsChatInline
          targetType={targetType}
          targetId={targetId}
          currentUserKey={currentUserKey}
          title={undefined} 
          onCreated={onCreated}
         
        />
      </div>
    </div>
  );
};

export default InternalCommentsChatDock;
